'use strict';

var angular = require('angular');
var dependencies = ['AVRO.FaresOptimizer.Common.DataTransformer'];
module.exports = angular.module('AVRO.FaresOptimizer.Common.FareTooltip', dependencies).factory('FaresOptimizerFareTooltipService', require('./services/FaresOptimizerFareTooltipService')).constant('FaresOptimizerConstants', require('../../constants/FaresOptimizerConstants'));